// extracted by mini-css-extract-plugin
export var circle = "_94-1";
export var exitConfirmationModal = "_94-5";
export var iframe = "_94-0";
export var offline = "_94-3";
export var online = "_94-2";
export var workstationSelectError = "_94-4";